import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type { AgentJobCalendarEvent } from './types';
import { AGENT_JOB_CALENDAR_FOLDER_ID } from './constants';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

/**
 * Type guard: true when the event is a synthetic agent-job tile (recognized by its virtual
 * parent folder). Narrows to AgentJobCalendarEvent so callers can read agentJobState/agentJobId.
 */
export function isAgentJobEvent(event: CalendarEvent | undefined): event is AgentJobCalendarEvent {
    return (
        isGlobalFeatureEnabled('cal-agent-jobs-panel') &&
        event?.ParentFolderId?.Id === AGENT_JOB_CALENDAR_FOLDER_ID
    );
}
